module.exports = __webpack_public_path__ + "static/media/check-filled.4d37c44e.svg";